import type { SVGProps } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      stroke="#FF073B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
    />
    <g fill="#FF073B" clipPath="url(#info_svg__a)">
      <path d="M10.779 15.074v-2.59c-.756-.19-1.002-.642-.75-1.433.047-.149.276-.32.427-.325.742-.034 1.487-.022 2.23-.014.364.004.491.23.488.605-.011 1.078-.004 2.153-.004 3.23v.514c.75.127 1.098.803.774 1.475-.069.145-.313.268-.48.272-.986.025-1.973.012-2.959.014-.33 0-.513-.157-.517-.525q-.002-.147-.004-.294c-.003-.793.026-.829.793-.929zM11.968 9.294c-1.195-.014-1.167.194-1.16-1.28.004-.779.053-.834.776-.836.362 0 .727-.004 1.09.002.323.006.507.169.498.543-.007.34-.01.684 0 1.026.013.4-.164.563-.524.545-.226-.01-.454-.002-.682 0z" />
    </g>
    <defs>
      <clipPath id="info_svg__a">
        <path fill="#fff" d="M9.934 7.178h4.133v9.643H9.934z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfo;
